import React, { useEffect, useRef } from "react";
import ShopLayout1 from "components/layouts/ShopLayout1";
import Navbar from "components/navbar/Navbar";
import { ProductsApi } from "modules/products/api";
import { Product } from "modules/products/types";
import CategorySectionHeader from "components/CategorySectionHeader";
import { Container, Grid } from "@mui/material";
import ProductCard1 from "components/product-cards/ProductCard1";
import { map } from "lodash";
import { colors } from "common";

const AMDGamersFirst: React.FC = () => {
  const [amdGPUs, setAmdGPUs] = React.useState<Product[]>([]);

  const fetchAMDGamersFirst = async () => {
    const payload = {
      limit: 48,
      sort_direction: "asc",
      qcategory: "GPU",
      keyword: "radeon",
    };

    const res = await ProductsApi.getProducts(payload);

    if (res?.ok) {
      setAmdGPUs(res?.data?.data || []);
    }
  };

  useEffect(() => {
    fetchAMDGamersFirst();
  }, []);

  return (
    <ShopLayout1
      title="Performance to Advance Your Adventure"
      navbar={<Navbar />}
    >
      <iframe
        width="100%"
        height="3280px"
        title="AMD Gamers First"
        src="/html/amd/index.html"
        style={{ border: "none", marginBottom: -30 }}
      />

      <div style={{ background: colors.black, paddingBottom: 50 }}>
        {amdGPUs?.length > 0 && (
          <Container maxWidth="lg">
            <CategorySectionHeader
              title="AMD GPUs"
              titleStyle={{ color: colors.white }}
            />
            <Grid container spacing={1} mt={2}>
              {map(amdGPUs, (item, ind) => (
                <Grid item md={2} sm={4} xs={6} key={ind}>
                  <ProductCard1 hoverEffect productData={item} />
                </Grid>
              ))}
            </Grid>
          </Container>
        )}
      </div>
    </ShopLayout1>
  );
};

export default AMDGamersFirst;
